import AnnualLeasingAmountError from './AnnualLeasingAmountError';
class InvalidCrowdfundingPropertyID extends AnnualLeasingAmountError {
    propertyId;
    constructor(propertyId, options) {
        super('INVALID_CROWDFUNDING_PROPERTY_ID', options);
        this.propertyId = propertyId;
    }
}
export default InvalidCrowdfundingPropertyID;
